import Script from 'next/script';
import React from 'react';
import logger from 'utils/logger';

interface IInlineScriptProps {
  id?: string;
  strategy?: 'afterInteractive' | 'lazyOnload';
  children: () => void;
}

const InlineScript: React.FC<IInlineScriptProps> = (props) => {
  if (process.env.NODE_ENV === 'development') {
    const fn = props.children;
    if (typeof fn !== 'function' || fn.length > 0) {
      throw new Error(
        `ContentScript: 确保props.children为无参数的匿名函数！ type: ${typeof fn}, name: ${
          fn.name
        }`,
      );
    }
    if (!props.id || `${props.id}`.trim().length === 0) {
      logger.warn('ContentScript: 建议为InlineScript设置一个唯一ID.');
    }
  }

  const html = `(${props.children.toString()})()`;

  return (
    <Script
      id={props.id}
      dangerouslySetInnerHTML={{ __html: html }}
      strategy={props.strategy || 'afterInteractive'}
    />
  );
};

export default InlineScript;
